__turbopack_context__.v({
  "Separator": "EditTeamForm-module-scss-module__z6oDUW__Separator",
  "body": "EditTeamForm-module-scss-module__z6oDUW__body",
  "deleteBtn": "EditTeamForm-module-scss-module__z6oDUW__deleteBtn",
  "details": "EditTeamForm-module-scss-module__z6oDUW__details",
  "expItem": "EditTeamForm-module-scss-module__z6oDUW__expItem",
  "link": "EditTeamForm-module-scss-module__z6oDUW__link",
  "logo": "EditTeamForm-module-scss-module__z6oDUW__logo",
  "primaryLabel": "EditTeamForm-module-scss-module__z6oDUW__primaryLabel",
  "row": "EditTeamForm-module-scss-module__z6oDUW__row",
  "secondaryLabel": "EditTeamForm-module-scss-module__z6oDUW__secondaryLabel",
});
